import React, { useState } from "react"
import styled from "styled-components"
import CompleteForm from "./CompleteForm"
import NextImg from "@/common/components/NextImg/index"

import QABackground from "@/containers/MoneyFortune/View/questions/QABackground"
import BGimg from "@/common/assets/image/moneyFortune/web3Plus/QABG.webp"

export default function CompleteQA({
  setPage,
  setName,
  name,
  summaryCount,
  email,
  setEmail,
  GetAndShare
}) {
  const [QAAnimation, setQAAnimation] = useState(false)

  return (
    <Wrapper className={QAAnimation === true && "active"}>
      <BGWrapper>
        <QABackground className={QAAnimation === true && "active"} />
        <BGIMGWrapper className={QAAnimation === true && "active"}>
          <NextImg src={BGimg} />
        </BGIMGWrapper>
      </BGWrapper>
      <FormWrapper className="FormWrapper">
        <CompleteForm
          setPage={setPage}
          setName={setName}
          name={name}
          setQAAnimation={setQAAnimation}
          QAAnimation={QAAnimation}
          summaryCount={summaryCount}
          setEmail={setEmail}
          email={email}
          GetAndShare={GetAndShare}
        />
      </FormWrapper>
      <Floor className={QAAnimation === true && "active"}>
        <p>Powered by KryptoGO</p>
      </Floor>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;

  &.active {
    .FormWrapper {
      opacity: 1;
      animation: zoomOut 1s forwards;
      will-change: transform;
    }
    .BGWrapper {
      opacity: 1;
      animation: fadOut 1s forwards;
    }
    .CircleBG {
      animation: fadOut 2s forwards 1s;
      .c1 {
        animation: circle 2s infinite ease reverse;
      }
      .c2 {
        animation: circle 2s infinite ease 0.5s reverse;
      }
      .c3 {
        animation: circle 2s infinite ease 1s reverse;
      }
    }
  }
  @keyframes zoomOut {
    50% {
      opacity: 1;
      transform: scale(1.2);
    }
    100% {
      opacity: 0;
      transform: scale(0.1) rotate(90deg);
      /* background-color: #00fff0; */
    }
  }
  @keyframes fadOut {
    100% {
      opacity: 0;
    }
  }
  @keyframes fadeIn {
    100% {
      opacity: 1;
    }
  }
`
const BGWrapper = styled.div`
  background-color: #000000;
  width: 100%;
  height: var(--vh);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  opacity: 0;
  will-change: transform;
  animation: fadeIn forwards 2s 1.5s;
`

const FormWrapper = styled.div`
  max-width: 800px;
  width: 100%;
  padding: 30px;
  z-index: 30;
  will-change: transform;
  opacity: 0;
  animation: fadeIn forwards 1s;
`
const Floor = styled.div`
  width: 100%;
  height: 50px;
  background: #4646f5;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: end;
  align-items: center;
  left: 0px;
  transition: 1s;
  z-index: 9999;
  p {
    text-align: right;
    padding: 20px;
    margin: 0 auto;
    width: clamp(0px, 100%, 1400px);
    @media (max-width: 768px) {
      text-align: center;
    }
  }
  &.active {
    opacity: 0;
  }
`

const BGIMGWrapper = styled.div`
  position: absolute;
  z-index: -1;
  width: 100%;
  top: 20vh;
  left: 0;
  height: 100%;
  transition: 0.7s 0.3s;
  &.active {
    opacity: 0;
    transform: scale(0.01);
  }
`
